/**
 * Created by commyfeng on 2017/3/21.
 */
import ZeptoJSONP from "./ZeptoJSONP";
import Retry from "./Retry";
import Crequest from "./Crequest";
import Qrequest from "./Qrequest";
import Report from "./Report";
import Timeout from "./Timeout";
import Fallback from "./Fallback";
import Method from "./Method";
export default function extend(Coa) {
  Coa.ZeptoJSONP = ZeptoJSONP;
  Coa.Retry = Retry;
  Coa.Crequest = Crequest;
  Coa.Qrequest = Qrequest;
  Coa.Report = Report;
  Coa.Timeout = Timeout;
  Coa.Fallback = Fallback;
  Coa.Method = Method;
}